<div class="d-flex justify-content-start align-items-center" *ngIf="surveyService.componentName == 'inventory'">
    <div class="form-label fw-bold">Filter:</div>
    <div class="p-2" *ngFor="let filter of filters; let i=index;">
        <div class="label">{{ filter.name }}</div>
        <select
          class="form-select form-select-solid" (change)="onFilterChange(i)" [(ngModel)]="filter.selected">
          <option selected disabled [value]="null">Select {{ filter.name }}</option>
          <ng-container *ngFor="let option of filter.options; let subI = index;">
            <option [value]="option.value">{{ option.key }}</option>
          </ng-container>
        </select>
    </div>
  </div>
